module.exports = __webpack_public_path__ + "files/e5978bffe22820c3b47beeddb5c913a0.png";